import "@babel/polyfill";
import * as Sentry from "@sentry/browser";
import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import App from "./App";
import F from "./Functions";

Sentry.init({
  dsn: "https://9cbb2c9056f9433d8499445c08501d95@sentry.io/1222713",
  environment: process.env.NODE_ENV,
});


$(document).mouseup(function(e) {
  // var container = $("#myDropdown");
  // if the target of the click isn't the container nor a descendant of the container
  if (
    $(e.target)
      .parents("button")
      .attr("className") !== "dropdownbtn" &&
    $(e.target).parent().length > 0 &&
    $(e.target).parent()[0].className !== "anticon anticon-delete" &&
    $(e.target).parent()[0].className !==
      "dropdown-content notification_dropdown" &&
    $(e.target).parent()[0].className !== "ant-col ant-col-md-20" &&
    $(e.target).parent()[0].className
  ) {
    F.log($(e.target).parent()[0].className.symbol);
    if ($(".dropdown-content").length > 0) {
      $(".dropdownbtn").trigger("click");
    }
  }
});

//import registerServiceWorker from './registerServiceWorker';

//[];(function(){var uv=document.createElement('script');uv.type='text/javascript';uv.async=true;uv.src='//widget.uservoice.com/fyty0Sqgib6x84aHdMGDqg.js';var s=document.getElementsByTagName('script')[0];s.parentNode.insertBefore(uv,s)})();

//window.Raven.config('https://9cbb2c9056f9433d8499445c08501d95@sentry.io/1222713').install()

ReactDOM.render(<App />, document.getElementById("root"));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js